export const physiologicalTempRegex = generateNumberRegEx(2,1);
export const weightRegex = generateNumberRegEx(3,2);
export const heightRegex = generateNumberRegEx(3,2);

/**
 * Generates a regular expression to validate a non-negative number with specific constraints.
 * This version is optimized for dynamic input (allows trailing decimal point for easier deletion).
 *
 * @param {number} integerCount - The maximum number of digits allowed before the decimal point (the integer part).
 * @param {number} decimalCount - The maximum number of digits allowed after the decimal point (the fractional part).
 * @returns {RegExp | string} A RegExp object for validation, or a hyphen '-' if both counts are zero or invalid.
 */
function generateNumberRegEx(integerCount, decimalCount) {
    // 1. Validate and Coerce Inputs
    // Ensure counts are non-negative integers. If not, treat them as 0.
    const maxIntDigits = Math.max(0, parseInt(integerCount, 10) || 0);
    const maxDecDigits = Math.max(0, parseInt(decimalCount, 10) || 0);

    // 2. Handle Edge Case: No digits allowed
    if (maxIntDigits === 0 && maxDecDigits === 0) {
        return "-";
    }

    // 3. Build the Components

    // A. Start anchor: ^
    const start = "^";

    // B. Integer part: \d{0,maxIntDigits}
    // We allow 0 digits before the decimal to permit numbers like ".5" (when decimalCount > 0)
    let integerPart = `\\d{0,${maxIntDigits}}`;
    
    // C. Decimal/Fractional part: (\.\d{0,maxDecDigits})?
    // This part is an optional group, allowing a trailing dot (.\d{0,Y}) for dynamic input/deletion.
    let decimalPart = "";
    if (maxDecDigits > 0) {
        decimalPart = `(\\.\\d{0,${maxDecDigits}})?`;
    }
    
    // 4. Combine and Create RegExp
    // The pattern is anchored at the start (^) and end ($) to match the whole string.
    const pattern = start + integerPart + decimalPart + "$";
    
    // Note: The logic has been slightly adjusted from your previous versions 
    // to use \d{0,Y} in the decimal part for better input/deletion UX, 
    // while keeping the integer part flexibility.
    
    return new RegExp(pattern);
}